import {
  GET_USER_NATIONAL_ID_REQUEST,
  GET_USER_NATIONAL_ID_SUCCESS,
  GET_USER_NATIONAL_ID_FAILURE,
} from 'Store/constants';
  
const initialState = {
  data: {},
  isLoading: false,
  error: null
};
  
export default (state = initialState, action) => {
  switch (action.type) {
    case GET_USER_NATIONAL_ID_REQUEST:
      return { ...state, isLoading: true, error: null };
    case GET_USER_NATIONAL_ID_SUCCESS:
      return { ...state, data: action.payload, isLoading: false, error: null };
    case GET_USER_NATIONAL_ID_FAILURE:
      return { ...state, isLoading: false, error: action.payload };
    default:
      return state;
  }
};
  